/**
 * SkipLink Component
 * Provides keyboard users with a way to skip directly to main content
 * WCAG 2.1 AA - Bypass Blocks (2.4.1)
 */

import React from 'react';

interface SkipLinkProps {
  href?: string;
  children?: React.ReactNode;
}

export function SkipLink({ href = '#main-content', children = 'Saltar al contenido principal' }: SkipLinkProps) {
  return (
    <a
      href={href}
      className="
        sr-only
        focus:not-sr-only
        focus:absolute
        focus:top-4
        focus:left-4
        focus:z-50
        focus:px-6
        focus:py-3
        focus:bg-primary
        focus:text-white
        focus:rounded-lg
        focus:shadow-lg
        focus:outline-none
        focus:ring-2
        focus:ring-white
        focus:ring-offset-2
        focus:ring-offset-primary
      "
    >
      {children}
    </a>
  );
}

export default SkipLink;
